import * as React from 'react';

import { Flex, Text } from '@opendoor/bricks/core';

import { useAppSelector } from 'src/store/hooks';

const Header: React.FC<React.PropsWithChildren> = ({ children }) => {
  const streetAddress = useAppSelector((state) => state.sellerInput.address.street);
  // additional values needed for 768-991 screens (there is no novo breakpoint here)
  // for now instead:
  // at 768 we use the 922px settings from the figma doc
  return (
    <Flex
      minHeight={['56px', null, '64px']}
      fontSize={['14px', null, '16px']}
      marginX="auto"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      backgroundColor="white0"
    >
      <Text fontWeight="medium">{streetAddress}</Text>
      {children}
    </Flex>
  );
};

export default Header;
